import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { BrandingOption, HelpButton, HelpButtonAction } from '../../stores/BrowserBarOptions';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import {
    BrandingOptionField,
    BrandingOptionView, HelpButtonActionField, HelpButtonActionView,
    HelpButtonField,
    HelpButtonView
} from '../BrowserBarOptions/BrowserBarFields';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import { Card, Field } from '../Fuse';
import NewFuseWysiwyg from '../Fuse/NewFuseWysiwyg';
import FuseRadioButton from '../FuseControls/FuseRadioButton';
import FuseTextfield from '../FuseControls/FuseTextfield';
import BaseCustomizeEditModal from './BaseCustomizeEditModal';

class CustomizeBrowserBarModal extends Component {
    static propTypes = {
        customizeUI: CustomizeUIStore.PropType.isRequired,
    };

    renderRadioButtons = (values, store, views, qa) => values.map((value) => <FuseRadioButton
        key={value}
        store={store}
        value={value}
        label={views[value]}
        qa={`${qa}-${value}`}
    />);

    render() {
        const { browserBarOptions } = this.props.customizeUI;
        return <BaseCustomizeEditModal store={browserBarOptions}>
            <Card title="Branding">
                <BrandingOptionField tooltipProps={{ position: 'right' }}>
                    {this.renderRadioButtons([
                        BrandingOption.DEFAULT,
                        BrandingOption.CUSTOM,
                    ], browserBarOptions.brandingOption, BrandingOptionView, 'branding-option')}
                </BrandingOptionField>
                {browserBarOptions.isCustomBrandingEditable() ? <Fragment>
                    <Field>
                        <FuseTextfield
                            store={browserBarOptions.customBrandingText}
                            label="Custom Branding"
                            required
                            showRequired
                            // TODO: this should be part of FuseTextfield
                            error={browserBarOptions.customBrandingText.hasChanged()
                                && !browserBarOptions.customBrandingText.isValid()}
                            bottomText={browserBarOptions.customBrandingText.hasChanged()
                                && browserBarOptions.customBrandingText.errorMessage}
                            qa="custom-branding-text"
                        />
                    </Field>
                    <FuseConsoleCardFooter
                        text={`Custom branding will not be translated to other languages
                              and cannot exceed ${browserBarOptions.customBrandingTextMaxLength} characters.`}
                    />
                </Fragment> : null}
            </Card>
            <Card title="Help Link">
                <HelpButtonField tooltipProps={{ position: 'right' }}>
                    {this.renderRadioButtons([
                        HelpButton.DISABLED,
                        HelpButton.ICON,
                        ...(browserBarOptions.brandingOption.equals(BrandingOption.CUSTOM)
                            ? [HelpButton.BRANDING] : []),
                    ], browserBarOptions.helpButton, HelpButtonView, 'help-button')}
                </HelpButtonField>
                {browserBarOptions.helpButton.equals(HelpButton.DISABLED) ? null : <Fragment>
                    <HelpButtonActionField tooltipProps={{ position: 'right' }}>
                        {this.renderRadioButtons([
                            HelpButtonAction.LINK,
                            HelpButtonAction.POPUP,
                        ], browserBarOptions.helpButtonAction, HelpButtonActionView, 'help-button-action')}
                    </HelpButtonActionField>
                    {browserBarOptions.isExternalLinkEditable() ? <Field>
                        <FuseTextfield
                            store={browserBarOptions.externalLink}
                            label="External Link"
                            required
                            showRequired
                            fullWidth
                            error={browserBarOptions.externalLink.hasChanged()
                            && !browserBarOptions.externalLink.isValid()}
                            bottomText={browserBarOptions.externalLink.hasChanged()
                            && browserBarOptions.externalLink.errorMessage}
                            qa="external-link"
                        />
                    </Field> : null}
                    {browserBarOptions.isPopupContentEditable() ? <Field
                        label="Popup Message"
                        caption="&nbsp;(required)"
                    >
                        <NewFuseWysiwyg
                            store={browserBarOptions.popupContent}
                            ref={browserBarOptions.popupContent.ref}
                        />
                    </Field> : null}
                </Fragment>}
            </Card>
        </BaseCustomizeEditModal>;
    }
}
export default inject('customizeUI')(observer(CustomizeBrowserBarModal));
